import {PRODUCT} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';

export const authorizationObject = {
    [PRODUCT]: SECURITY_PRIVILEGES_READ,
};
